import React, { useEffect, useState } from "react";
import UserBillingMilestoneProgressItem from "./UserBillingMilestoneProgressItem";
import { CheckIcon } from "@heroicons/react/16/solid";
import TrophyView from "./milestone/TrophyView";
function UserBillingMilestoneProgress({ milestones, userAmount }) {
  const [count, setCount] = useState(0);
  const [amountMilestones, setAmountMilestones] = useState([]);

  useEffect(() => {
    setCount(milestones.length);
    for (let i = 0; i < milestones.length; i++) {
      setAmountMilestones((prev) => {
        let updated = [...prev];
        updated[i] = userAmount >= milestones[i].targetAmount;
        return updated;
      });
    }
  }, [milestones, userAmount]);

  return (
    <div className="p-2 rounded-md">
      <div className="flex flex-col gap-2">
        {milestones.map((m, i) => (
          <div
            className={`flex flex-row gap-6 justify-start items-center py-3 px-4  ${
              amountMilestones[i]
                ? "text-yellow-500 bg-neutral-light"
                : "text-gray-500 bg-gray-100"
            }`}
          >
            <div className="w-8 h-8">
              <TrophyView active={amountMilestones[i]} />
            </div>
            <div className="flex flex-col flex-grow gap-2">
              <span className="text-medium font-bold">€{m.targetAmount}</span>
              <span className="text-sm font-light">{m.description}</span>
            </div>
            <div
              className={`p-2 rounded-full justify-center items-center flex ${
                amountMilestones[i] ? "bg-primary" : "bg-gray-300"
              } `}
            >
              <CheckIcon
                className={`w-5 h-5 ${
                  amountMilestones[i] ? "text-white" : "text-gray-400"
                }`}
              />
            </div>
          </div>
        ))}
      </div>
    </div>
  );
  /*return (
    <div className="bg-neutral-light p-2 rounded-md">
      <div className="flex flex-row gap-0">
        {milestones.map((m, i) => (
          <div className={`flex-1 flex-grow h-auto py-8`} key={`${i}`}>
            <UserBillingMilestoneProgressItem
              milestone={m}
              active={amountMilestones[i]}
              nextActive={amountMilestones[i + 1]}
              isLast={i === count - 1}
            />
          </div>
        ))}
      </div>
    </div>
  );*/
}

export default UserBillingMilestoneProgress;
